import { NameFormatter } from './name-formatter';

export class BozNameFormatter implements NameFormatter {
    format(name: string): string {
        let lastIndex = name.lastIndexOf('.')

        if(lastIndex == -1){
            lastIndex = name.lastIndexOf('-');
        }

        return name.slice(lastIndex + 1).replace(/^0+/, '');
    }
}